<script setup lang="ts">
import { computed } from "vue";

import { TuiColorInput } from "@vm/tui";
import { useForm } from "@vm/vue-core";

import type { ComparisonSettings } from "../use-settings-editor-store";

const { formData } = useForm<ComparisonSettings>();

const typeEntries = computed(() =>
  Object.keys(formData.value.colors.typeColors ?? {}),
);
</script>

<template>
  <div class="space-y-4">
    <h2 class="text-lg font-medium text-gray-900">Type colors</h2>
    <p class="text-sm text-gray-500">
      Assign a background color to each object type. The column header will use
      this color.
    </p>

    <div v-if="typeEntries.length > 0" class="space-y-2">
      <div
        v-for="typeName in typeEntries"
        :key="typeName"
        class="flex items-center gap-3"
      >
        <TuiColorInput
          v-model="formData.colors.typeColors[typeName]"
          :label="typeName"
          :full-path="`colors_typeColors_${typeName}`"
          class="flex-1"
        />
      </div>
    </div>
  </div>
</template>
